import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'

import { getState } from "../helpers/getState";
import { updateCart } from "../helpers/updateCart";
import { getProduct } from "../helpers/getProduct-v2";
import { getRout } from "../helpers/getRout";
import {setContacts} from "../helpers/setContacts";
import {subscribeForm} from "../helpers/subscribeForm";

updateCart()
getRout()
subscribeForm()



getState((data) => {

  const $loader = $('.popup-loading-wrapper');

  const products = data.data.products;

  setContacts(data.data.templates)

  getProduct(products, 'ha-product__content');

  getProduct(products, 'home-product__content');

  getProduct(products, 'banner-flex');


  $loader.hide();
});
